const GROUP_ICON_MAP = {
  active: 'payments',
  passive: 'autoRenew',
};

const GROUP_TITLE_MAP = {
  active: 'Earned income',
  passive: 'Passive income',
};

const GROUP_SUBTITLE_MAP = {
  active: 'Money you earn from a job or any work you do right now.',
  passive: 'Money that comes in without you having to actively work for it.',
};

const useIncomeCategoryGroupData = () => {
  const getGroups = (resource) => {
    const options = resource.meta().field('options').options().list();
    return [...new Set(options.reduce((acc, opt) => [...acc, opt.attr('group')], []))];
  };

  const getIncomeCategoryGroupIcon = (group) => {
    if (GROUP_ICON_MAP[group]) {
      return GROUP_ICON_MAP[group];
    }
    return 'fac';
  };

  const getIncomeCategoryGroupTitle = (group) => {
    if (GROUP_TITLE_MAP[group]) {
      return GROUP_TITLE_MAP[group];
    }
    return 'Other income';
  };

  const getIncomeCategoryGroupSubtitle = (group) => {
    if (GROUP_SUBTITLE_MAP[group]) {
      return GROUP_SUBTITLE_MAP[group];
    }
    return 'Money that comes from other types of income';
  };

  const getIncomeCategoryGroupOptions = (resource, group) => {
    const options = resource.meta().field('options').options().list();
    return options.filter((option) => option.attr('group') === group).map(option => ({
      value: option.attr('id'),
      name: option.attr('prompt'),
    }));
  };

  return {
    getGroups,
    getIncomeCategoryGroupIcon,
    getIncomeCategoryGroupTitle,
    getIncomeCategoryGroupSubtitle,
    getIncomeCategoryGroupOptions,
  };
};

export { useIncomeCategoryGroupData };
